module.exports = __webpack_public_path__ + "icon-alertminer-flex.9e2a445fc8ed054816b9.png";